import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Discount Codes',
  basePath: '/shop-discount-codes',
  columns: [
    { key: 'code', label: 'Code', sortable: true },
    { key: 'value', label: 'Value', sortable: true },
    { key: 'active', label: 'Active', sortable: true,
      render: (v) => (/** @type {unknown} */ (v) === 1 || v === '1' || v === true) ? 'Yes' : 'No' },
    { key: 'code_date', label: 'Date', sortable: true },
  ],
  fields: [
    { key: 'code', label: 'Code', type: 'text', required: true },
    { key: 'value', label: 'Value', type: 'number' },
    { key: 'active', label: 'Active', type: 'yesno', defaultValue: 0 },
  ],
  defaultSort: { field: 'code_date', dir: 'desc' },
});
